import React, { Component } from "react";
import { connect } from "react-redux";
import Tabs from "../../components/Backlinks/BacklinksTabs";
import { getTabsSettings } from "../../store/backlinks/selectors";
import { getSelectedWebsiteDomain } from "../../store/tracked_websites/selectors";

class BacklinksTabs extends Component {
  render() {
    return <Tabs settings={this.props.settings} domain={this.props.domain} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  let domain = ownProps.domain || getSelectedWebsiteDomain(state);
  return {
    domain: domain,
    settings: getTabsSettings(state)
  };
};

export default connect(mapStateToProps, null)(BacklinksTabs);
